module.exports = __webpack_public_path__ + "static/media/home.a4fe2444.svg";